import { useState } from "react";
import { Button, Group, Modal, Stack, Text } from "@mantine/core";
import { IconFileTypePdf, IconFileTypeCsv } from "@tabler/icons-react";

type Props = {
  opened: boolean;
  onClose: () => void;
  onDownload: (format: "pdf" | "csv") => Promise<void>;
};

export default function DownloadFormatModal({ opened, onClose, onDownload }: Props) {
  const [loading, setLoading] = useState<"pdf" | "csv" | null>(null);

  const handleDownload = async (format: "pdf" | "csv") => {
    setLoading(format);
    try {
      await onDownload(format);
      onClose();
    } finally {
      setLoading(null);
    }
  };

  return (
    <Modal opened={opened} onClose={onClose} title="Download Report" centered size="sm">
      <Text size="sm" c="dimmed" mb="lg">
        Choose the format you would like to download the report in.
      </Text>
      <Group grow>
        <Stack align="center" gap="xs">
          <Button
            fullWidth
            variant="outline"
            color="red"
            leftSection={<IconFileTypePdf size={20} />}
            loading={loading === "pdf"}
            disabled={loading === "csv"}
            onClick={() => handleDownload("pdf")}
          >
            PDF
          </Button>
        </Stack>
        <Stack align="center" gap="xs">
          <Button
            fullWidth
            variant="outline"
            color="green"
            leftSection={<IconFileTypeCsv size={20} />}
            loading={loading === "csv"}
            disabled={loading === "pdf"}
            onClick={() => handleDownload("csv")}
          >
            CSV
          </Button>
        </Stack>
      </Group>
    </Modal>
  );
}
